export const passportTypes = ['Ordinary', 'Diplomatic', 'Official/Service ', 'Laissez-passer','Other Travel Document'];